<script setup>
import Error from '@/assets/icons/error.svg'
import Success from '@/assets/icons/success.svg'

defineProps({
    formMessageConfig: {
        type: Object,
        required: false,
        default: () => ({}),
        validator: (rawValue) => {
            const validations = {
                message: value => value.message === undefined || typeof value.message === 'string',
                success: value => value.success === undefined || typeof value.success === 'boolean',
                error: value => value.error === undefined || typeof value.error === 'boolean',
                isPending: value => value.isPending === undefined || typeof value.isPending === 'boolean',
                statusCode: value => value.statusCode === undefined || typeof value.statusCode === 'number'
            }

            return Object.entries(validations).every(([_, validation]) => validation(rawValue))
        }
    }
})

// Emit null status on unmount
onUnmounted(() => {
    emit('update:setStatus', null)
})

// Define emits
const emit = defineEmits(['update:setStatus'])
</script>

<template>
    <Transition name="fade">
        <div
            v-if="formMessageConfig?.statusCode || formMessageConfig?.message"
            class="form-message"
            :class="formMessageConfig?.success ? 'success-message' : 'error-message'"
            @click="emit('update:setStatus', null)"
        >
            <Component :is="formMessageConfig?.success ? Success : Error" />

            <div class="message-body">
                <p>{{ formMessageConfig?.message }}</p>
            </div>
        </div>
    </Transition>
</template>

<style lang="scss">
.form-message {
    @include form-message;

    .message-body {
        width: calc(100% - 48px);
        text-align: left;
    }
}
</style>
